import {
  CommandBar,
  ICommandBarItemProps,
  Persona,
  PersonaPresence,
  PersonaSize,
  Spinner,
} from "@fluentui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { AppRoutes } from "../../Constants/AppRoutes";
import { IUser } from "../../Models/IUser";
import { GenericActions } from "../../Redux/Generic/GenericAction";
import { GlobalState } from "../../Redux/RootReducer";
import BetterPersona from "../BetterPersona/BetterPersona";
import "./CustomCommandBar.scss";

export interface ICommandBarProps {
  isLoading?: boolean;
  specials?: JSX.Element[];
  buttons?: ICommandBarItemProps[];
}

const CustomCommandBar = (props: ICommandBarProps) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (props.isLoading !== undefined) {
      setLoading(props.isLoading);
    }
  }, [props.isLoading]);

  return (
    <div className="command-bar-wrapper">
      {!loading && (
        <div className="command-bar-line-wrap">
          {(props.specials ?? []).map((x: JSX.Element, i: number) => {
            return <div key={i}>{x}</div>;
          })}
          <div className="command-bar-wide-wrap">
            <CommandBar
              items={(props.buttons ?? []).map(
                (x: ICommandBarItemProps, i: number) => {
                  x["key"] = i.toString();
                  return x;
                }
              )}
              farItems={[]}
            />
          </div>
          <BetterPersona />
        </div>
      )}
      {loading && <Spinner label="Attendere..." labelPosition="right" />}
    </div>
  );
};

export default CustomCommandBar;
